module.exports = __webpack_public_path__ + "static/media/logobakeli.7b1feddc.png";